import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { httpService } from '../../../services/http.service';
import { IMoveMoneyReviewResponse, IServerErrorResponse } from '../../../types';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { endpointManager } from '../../../services/endpoint.service';

interface IWireOutReview {
    billId?: string;
    supplierId: string;
    amount: number;
    note: string;
}

export const postWireOutReview = () => {
  const { postWireOutReviewUrl } = endpointManager();
  return useMutation(
    'postWireOutReview',
    async ({
      supplierId, amount, note, billId,
    }: IWireOutReview): Promise<IMoveMoneyReviewResponse> => {
      const res = await httpService.post(
        postWireOutReviewUrl(billId),
        {
          supplierId,
          amount,
          note,
        },
      );
      return res.data.mfaActionData;
    },
    {
      onError: (error: IServerErrorResponse) => {
        const { localizedMessage } = flattenServerErrorResponse(error);
        toast(<LiliNotification undismissable type={LiliNotificationType.ERROR} text={localizedMessage} id='vendorDetailsError' />, { ...LiliToastDefaultConfig });
      },
    },
  );
};
